import { render } from "./HeroiconsSolidChatAlt2.vue?vue&type=template&id=87e9eb88"
const script = {}

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidChatAlt2.vue"]])

export default __exports__